<template>
  <div v-if="isVisible" class="back-button z-20 fixed ml-0.5 top-[160px]">
    <a :href="previousPage" @click="handleClick">
      <OIcon icon="back" :svg-style="'width: 36px'" />
    </a>
  </div>
</template>
<script>
import { defineComponent, onMounted, ref, onUnmounted, computed } from '@nuxtjs/composition-api';
import { throttle } from 'lodash';
import { useDevice } from '~/composables/useDevice';
import { HOST_URL, IS_ONEDIO } from '~/constants/config';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    isArticlePage: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const isVisible = ref(false);
    const getScrollPercent = () => {
      const h = document.documentElement;
      const b = document.body;
      const st = 'scrollTop';
      const sh = 'scrollHeight';
      return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    };
    const toggleVisibility = throttle(() => {
      isVisible.value = getScrollPercent() > 10 && isMobile.value;
    }, 100);
    onMounted(() => {
      isVisible.value = getScrollPercent() > 10 && isMobile.value;
      window.addEventListener('scroll', toggleVisibility);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', toggleVisibility);
    });

    const previousPage = computed(() => {
      const kesfetClick = process.client ? localStorage.getItem('o-bb-kesfet-click') : null;
      if (!kesfetClick && props.isArticlePage && IS_ONEDIO) {
        return '/kesfet';
      }
      if (
        process.client &&
        history.length > 1 &&
        document.referrer &&
        document.referrer.includes(HOST_URL) &&
        !document.referrer.includes('/kesfet')
      ) {
        return document.referrer;
      }
      return '/';
    });

    const handleClick = () => {
      if (props.isArticlePage && IS_ONEDIO) {
        localStorage.setItem('o-bb-kesfet-click', 'true');
      }
    };

    return { isVisible, previousPage, handleClick };
  },
});
</script>
